<div *ngFor="let tag of model; let i = index" class="sdeskTags">
  {{tag}}
  <i (click)="removeTag(i)"  class="fas fa-times divLink"></i>
</div>

<input [(ngModel)]="formText" class="tagsInput" type="text" [placeholder]="formPlaceholder" (keyup.enter)="addTag()">
